'use client';

import React from 'react';

import { TasticProps } from 'frontastic/tastics/types';
import { RenovationGuideProps } from 'components/commercetools-ui/organisms/renovation-guide';
import RenovationPage from 'components/commercetools-ui/organisms/renovation-guide';
import BlogPostSchema from 'components/commercetools-ui/organisms/blogpost-schema';

const RenovationPageTastic = ({ data, seoData, logoUrl }: TasticProps<RenovationGuideProps>) => {
  const dataSource = (data as any)?.data?.dataSource;
  return (
    <>
      <BlogPostSchema
        url={dataSource?.url}
        datePublished={dataSource?.date}
        imageUrl={dataSource?.featured_image?.url}
        seoData={seoData}
        logoUrl={logoUrl}
      />
      <RenovationPage data={data?.data?.dataSource} image={undefined} />
    </>
  );
};

export default RenovationPageTastic;
